import React from "react";
import classNames from "classnames/bind";

// components
// import SearchInput from "./SearchInput";

// assets
import { ChevronDown, SearchIcon } from "src/assets/icons";

import styles from "./TopSection.module.scss";
const cx = classNames.bind(styles);

const TopSection = ({ handleInputChange }) => {
  return (
    <div className={cx("top-section-root")}>
      <p className={cx("sub-heading")}>Categories</p>
      <div className={cx("row")}>
        <div className={cx("category-wrapper")}>
          <div className={cx("pill")}>
            <span>Days</span>
            <ChevronDown />
          </div>
          <div className={cx("pill")}>
            <span>Event Type</span>
            <ChevronDown />
          </div>
          <div className={cx("pill")}>
            <span>Categories</span>
            <ChevronDown />
          </div>
          <div className={cx("pill")}>
            <span>Distance</span>
            <ChevronDown />
          </div>
        </div>
        <div className={cx("search-wrapper")}>
          <div className={cx("search-input")}>
            <SearchIcon />
            <input
              type="text"
              placeholder="Find events"
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSection;
